import { toOptionalString } from "../migration/toOptionalString.js";
import { convertDateToRenewDateTime } from "../../../subscription-contract/utils/convertDateToRenewDateTime.js";
function parsePauseDate(dateString) {
    const string = toOptionalString(dateString);
    if (!string)
        return undefined;
    try {
        const iso = convertDateToRenewDateTime(string);
        const date = new Date(iso);
        return Number.isNaN(date.getTime()) ? undefined : date;
    }
    catch {
        return undefined;
    }
}
export const getPauseErrors = (contract, prev = {}) => {
    const errors = { ...prev };
    const start = parsePauseDate(contract.pause_start);
    const stop = parsePauseDate(contract.pause_stop);
    if (!start && stop) {
        errors.pause_start = [
            ...(errors.pause_start ?? []),
            "Pause-Start mangler, men Pause-Stopp er satt.",
        ];
    }
    if (start && stop && stop.getTime() < start.getTime()) {
        errors.pause_stop = [
            ...(errors.pause_stop ?? []),
            "Pause-Stopp kan ikke være før Pause-Start.",
        ];
    }
    if (start && stop && stop.getTime() === start.getTime()) {
        errors.pause_stop = [
            ...(errors.pause_stop ?? []),
            "Pause-Start og Pause-Stopp kan ikke være like.",
        ];
    }
    const now = new Date();
    if (start && start.getTime() > now.getTime()) {
        errors.pause_start = [
            ...(errors.pause_start ?? []),
            stop
                ? "Pause-Start kan ikke være i fremtiden."
                : "Pause-Stopp mangler og Pause-Start kan ikke være i fremtiden.",
        ];
    }
    return errors;
};
